// Sonar/client/ui/RoutinesCrud.js
import { ComponentBase } from "../../core/ComponentBase.js";

export class RoutinesCrud extends ComponentBase {
    constructor(config) {
        super(config);
        this.dataCrud = null;
    }

    async initialize() {
        this.dataCrud = await this.createManagedComponent("DataCrud", null, {
            instanceId: "sonar-routines-crud",
            rpcClass: "RoutineRpc",
            schemaPath: "collections/routines",
            title: "My Routines",
            layout: 'horizontal',
            layoutConfig: { formWidth: '600px' },
            viewConfig: {
                mode: 'grid',
                fields: [
                    { name: 'name', label: 'Name', render: (val) => `<strong>${val}</strong>` },
                    // --- UPDATED: Show instructions instead of target ---
                    { name: 'instructions', label: 'Instructions', render: (val) => `<p class="text-truncate d-inline-block mb-0" style="max-width: 300px;">${val}</p>` },
                    // --- END UPDATED ---
                    { name: 'trigger.config.cron', label: 'Schedule', render: (val) => `<code>${val || 'N/A'}</code>` },
                    { name: 'isActive', label: 'Active', render: (val) => val ? '<i class="bi bi-check-circle-fill text-success"></i>' : '<i class="bi bi-x-circle text-muted"></i>' },
                    { name: 'nextRunAt', label: 'Next Run', render: (val) => val ? new Date(val).toLocaleString() : 'N/A' }
                ],
                toolbar: { create: { enabled: true, label: "New Routine" } }
            },
            formConfig: {
                fields: {
                    // --- UPDATED: Form fields for the new schema ---
                    name: { type: 'text', label: 'Routine Name', required: true },
                    instructions: { type: 'textarea', label: 'Instructions', required: true, rows: 5, placeholder: 'e.g., Search for "new AI startups on TechCrunch" every day and summarize the findings.' },
                    'trigger.config.cron': { type: 'text', label: 'Schedule (Cron)', required: true, placeholder: 'e.g., 0 8 * * 1-5 for 8 AM on weekdays' },
                    isActive: { type: 'boolean', label: 'Enable this routine' }
                    // --- END UPDATED ---
                },
            },
            dataConfig: {
                autoLoad: false
            }
        });
        await super.initialize();
    }

    async initAfterLogin() {
        if (this.dataCrud) {
            this.dataCrud.refreshData();
        }
    }

    async render() {
        return await this.dataCrud.render();
    }
}